// Consent-gated marketing tags. Nothing loads unless the ID is set AND the visitor consented.
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const ADS_LEAD_LABEL = process.env.REACT_APP_GOOGLE_ADS_LEAD_LABEL || "";

let state = { analytics: false, advertising: false };
let gtagLoaded = false;
let pixelLoaded = false;

const loadScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

const googleConsent = (c) => ({
  analytics_storage: c.analytics ? "granted" : "denied",
  ad_storage: c.advertising ? "granted" : "denied",
  ad_user_data: c.advertising ? "granted" : "denied",
  ad_personalization: c.advertising ? "granted" : "denied",
});

const initGtag = () => {
  if (gtagLoaded || !(GA4_ID || ADS_ID)) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("consent", "default", googleConsent({ analytics: false, advertising: false }));
  loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_ID || ADS_ID}`);
  window.gtag("js", new Date());
  if (GA4_ID) window.gtag("config", GA4_ID, { send_page_view: false });
  if (ADS_ID) window.gtag("config", ADS_ID);
  gtagLoaded = true;
};

const initPixel = () => {
  if (pixelLoaded || !META_PIXEL_ID) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("init", META_PIXEL_ID);
  pixelLoaded = true;
};

export const applyConsent = (consent) => {
  state = { analytics: Boolean(consent?.analytics), advertising: Boolean(consent?.advertising) };
  if (state.analytics || state.advertising) initGtag();
  if (gtagLoaded) window.gtag("consent", "update", googleConsent(state));
  if (state.advertising) initPixel();
  if (pixelLoaded) window.fbq("consent", state.advertising ? "grant" : "revoke");
};

export const trackPageView = (path) => {
  if (gtagLoaded && state.analytics && GA4_ID) window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
  if (pixelLoaded && state.advertising) window.fbq("track", "PageView");
};

export const trackLead = (source) => {
  if (gtagLoaded && state.analytics && GA4_ID) window.gtag("event", "generate_lead", { form_location: source });
  if (gtagLoaded && state.advertising && ADS_ID && ADS_LEAD_LABEL) window.gtag("event", "conversion", { send_to: `${ADS_ID}/${ADS_LEAD_LABEL}` });
  if (pixelLoaded && state.advertising) window.fbq("track", "Lead", { content_name: "early_access" });
};

export const trackingStatus = () => ({ meta: Boolean(META_PIXEL_ID), ga4: Boolean(GA4_ID), googleAds: Boolean(ADS_ID && ADS_LEAD_LABEL) });
